<template>
  <div class="map">
    <div class="map_wrap">
      <loader
        v-if="loading"
        :absolute="true"
        :fixed="false"
      />
      <div v-else class="map_body">
        <client-only>
          <yandex-map
            :coords="center"
            :zoom="zoom"
            :behaviors="mapBehaviors"
            :use-object-manager="true"
            @map-was-initialized="mapOnInit"
          >
            <ymap-marker
              v-for="(p, i) in polygons"
              :marker-id="p.id"
              :marker-stroke="p.strokeOptions"
              :marker-fill="p.fillOptions"
              :coords="p.area"
              :key="`mappoly-${ i }`"
              :balloon-template="getBallonTemplete(p)"
              marker-type="Polygon"
            />
            <!-- -->
          </yandex-map>
        </client-only>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '~/components/UI/PageLoader'

export default {
  components: { Loader },
  props: {
    enableDrag: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      loading: false,
      center: [60.061330, 30.314904],
      zoom: 3,
      polygons: [],
      mapBehaviors: [],
      mapBehaviorsDesctop: [
        'drag', 'dblClickZoom', 'rightMouseButtonMagnifier', 'dblClickZoom', 'multiTouch',
      ],
      mapBehaviorsMobile: [
        /* "drag", */ 'dblClickZoom', 'rightMouseButtonMagnifier', 'dblClickZoom', 'multiTouch',
      ],

    }
  },
  async fetch () {
    await this.loadMapData()
  },
  mounted () {
    this.setMapBehaviors()
  },
  created () {
    if (process.browser) {
      // this.setMapBehaviors()
    }
  },
  methods: {
    loadMapData () {
      this.loading = true
      return this.$store.dispatch('geo/fetchDeliveryMap')
        .then((res) => {
          this.polygons = res.polygons.map((v) => {
            return {
              id: v.id,
              name: v.name,
              // filial: v.filial,
              area: [v.area],
              fillOptions: {
                enabled: true,
                color: v.color || '#' + Math.random().toString(16).slice(3, 9),
                opacity: 0.7,
              },
              strokeOptions: {
                color: v.color || '#' + Math.random().toString(16).slice(3, 9),
                opacity: 0.1,
                width: 1,
              },
            }
          })
          this.center = res.center
          this.zoom = res.zoom
        })
        .finally(() => { this.loading = false })
        // .catch(() => false)
    },
    mapOnInit (map) {
      // console.log(map.geoObjects)
      // map.setBounds(map.geoObjects.getBounds(), { checkZoomRange: true, zoomMargin: 9 })
    },
    getBallonTemplete (p) {
      return '<p>' + p.name + ' (' + p.id + ')</p>'
    },
    setMapBehaviors () {
      this.mapBehaviors = this.mapBehaviorsMobile
      if (window && window.innerWidth > 768) {
        this.mapBehaviors = this.mapBehaviorsDesctop
      }
      if (this.enableDrag) {
        this.mapBehaviors.push('drag')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.map {
  width: 100%;
  display: flex;

  &_wrap {
    width: 100%;
    height: 600px;
    position: relative;

    @media screen and (max-width: 992px) {
      height: 450px;
    }
  }

  ::v-deep {
    .loader-component {
      z-index: 5;
    }
  }

  &_body {
    width: 100%;
    border-radius: 15px;
    box-shadow: 0 3px 36px rgba(122, 122, 122, .16);
    overflow: hidden;
  }

  &_loader {
    display: flex;

    img {
      width: 100%;
      height: 600px;
      object-fit: cover;
      object-position: center;

      @media screen and (max-width: 992px) {
        height: 450px;
      }
    }
  }
}

.ymap-container {
  width: 100%;
  height: 600px;

  @media screen and (max-width: 992px) {
    height: 450px;
    position: relative;

    /*&:after {
      content: '';
      width: 100%;
      height: 100%;
      background-color: transparent;
      position: absolute;
      top: 0;
      left: 0;
    }*/
  }

  & > div {
    width: 100%;

    & > ymaps {
      width: 100%;

      & > ymaps {
        width: 100%;
      }
    }
  }
}
</style>
